import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FiltrosConsultaSolicitudesIntermediarioDTO } from '../Model/filtrosConsultaSolicitudesIntermediarioDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable()
export class SolicitudIntermediarioService {
  public url: String;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'neoSolicitudIntermediario/';
  }

  getConteoSolicitudesIntermediario(idCliente): Observable<any> {
    return this._http.get(
      this.url + 'conteoSolicitudesIntermediario/' + idCliente
    ).pipe(catchError(HandleHttpError));
  }

  getEstadosIntermediario(idUsuario): Observable<any> {
    return this._http.get(this.url + 'estadosSolicitud/' + idUsuario).pipe(catchError(HandleHttpError));
  }

  consultarSolicitudesPorFiltro(
    filtrosConsulta: FiltrosConsultaSolicitudesIntermediarioDTO
  ): Observable<any[]> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post<any[]>(`${this.url}filtros`, filtrosConsulta, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  generarReporteSolicitudesPorFiltro(
    filtrosConsulta: FiltrosConsultaSolicitudesIntermediarioDTO
  ): Observable<any[]> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post<any[]>(`${this.url}reporteFiltros`, filtrosConsulta,
      {
        headers: headers,
      }
    ).pipe(catchError(HandleHttpError));
  }
}
